import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var NUDGES_QUERY_KEY = 'nudges';
var nudgeKeys = {
  nudges: [NUDGES_QUERY_KEY],
  nudgeList: function nudgeList(search, page) {
    return [NUDGES_QUERY_KEY, 'search', search, page].filter(Boolean);
  },
  singleNudge: function singleNudge(id) {
    return [NUDGES_QUERY_KEY, id];
  },
  nudgeLogs: function nudgeLogs(search) {
    return [NUDGES_QUERY_KEY, 'logs', search];
  },
  nudgeReport: function nudgeReport(_ref) {
    var id = _ref.id,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      search = _ref.search,
      progress = _ref.progress,
      offset = _ref.offset;
    return [NUDGES_QUERY_KEY, id, 'report', startDate, endDate, search, offset, progress];
  },
  nudgeStats: function nudgeStats(id, startDate, endDate) {
    return [NUDGES_QUERY_KEY, 'stats', id, startDate, endDate];
  },
  contentNudgeList: function contentNudgeList(contentId, page) {
    return [NUDGES_QUERY_KEY, 'contentList', contentId, page].filter(Boolean);
  }
};
export default nudgeKeys;